export default __webpack_public_path__ + "static/media/Armbands of the Deathstalker.6155835d.jpg";